/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import analytics from "analytics/analytics";
import baustein from "baustein";

export default baustein.register("product-overview", {
    defaultOptions: {},

    setupEvents(add) {
        add("readMoreText", this._onReadMoreText);
    },

    _onReadMoreText() {
        analytics.event("product_overview", "read_more_details");
    }
});

